export default "__VITE_ASSET__7aed7917__"